var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import React from 'react'
import { useColorString } from '../../hooks/useCSSStrings'
export var ODLongClickOverlay = function (props) {
  var longClickTime = props.longClickTime,
    _a = props.style,
    style = _a === void 0 ? {} : _a,
    c = props.color,
    children = props.children,
    onLongClick = props.onLongClick
  var color = useColorString(c)
  var _b = React.useState(false),
    clicking = _b[0],
    setClicking = _b[1]
  var _c = React.useState(0),
    elapsed = _c[0],
    setElapsed = _c[1]
  React.useEffect(
    function () {
      // tslint:disable-next-line:no-unnecessary-initializer
      var handler = undefined
      if (clicking) {
        var interval_1 = 50
        handler = setInterval(function () {
          setElapsed(function (el) {
            var value = Math.min(el + interval_1, longClickTime)
            if (value >= longClickTime) {
              onLongClick()
              clearInterval(handler)
              setElapsed(0)
              setClicking(false)
            }
            return value
          })
        }, interval_1)
        return function () {
          return clearInterval(handler)
        }
      } else {
        clearInterval(handler)
        setElapsed(0)
        setClicking(false)
      }
    },
    [clicking, longClickTime, onLongClick]
  )
  var width = Math.max(0, Math.min(100, (elapsed * 100) / Math.max(longClickTime, 100)))
  var mergedStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    backgroundColor: color,
    height: '100%',
    width: width + '%',
  }
  return React.createElement(
    'div',
    {
      style: __assign({ position: 'relative', backgroundColor: 'black', display: 'inline-block' }, style),
      onMouseDown: function () {
        return setClicking(true)
      },
      onMouseLeave: function () {
        return setClicking(false)
      },
      onMouseUp: function () {
        return setClicking(false)
      },
    },
    React.createElement('div', { style: mergedStyle }),
    children
  )
}
//# sourceMappingURL=ODLongClickOverlay.js.map
